import { Users } from "lucide-react";

export function NoTeamSelected() {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-3 text-muted-foreground">
      <Users className="h-12 w-12 opacity-30" />
      <p className="text-sm">상단에서 팀을 선택해주세요</p>
    </div>
  );
}
